var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import StarIcon from '../atoms/StarIcon';
var StarRating = function (_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.readonly, readonly = _c === void 0 ? false : _c;
    var _d = useState(null), hoverValue = _d[0], setHoverValue = _d[1];
    return (_jsx("div", __assign({ className: "star-rating" }, { children: [1, 2, 3, 4, 5].map(function (star) { return (_jsx(StarIcon, { filled: hoverValue ? star <= hoverValue : star <= value, size: size, onClick: function () { return !readonly && (onChange === null || onChange === void 0 ? void 0 : onChange(star)); }, onMouseEnter: function () { return !readonly && setHoverValue(star); }, onMouseLeave: function () { return !readonly && setHoverValue(null); } }, star)); }) })));
};
export default StarRating;
